export default "__VITE_ASSET__Dkm1UkKb__"